import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 首页保持同步导入，其他页面按需懒加载，减小首屏 bundle
import Home from '../views/Home.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'Home', component: Home, meta: { title: '甄选好游戏 秒玩趣无穷', tab: 0 } },
  { path: '/privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicy, meta: { title: '游戏盒子隐私政策' } },
  { path: '/category', name: 'Category', component: () => import(/* webpackChunkName: "category" */ '../views/Category.vue'), meta: { title: '游戏分类', tab: 1 } },
  { path: '/ranking', name: 'Ranking', component: () => import(/* webpackChunkName: "ranking" */ '../views/Ranking.vue'), meta: { title: '排行榜', tab: 2 } },
  { path: '/search', name: 'Search', component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue'), meta: { title: '搜索游戏' } },
  { path: '/records', name: 'GameRecords', component: () => import(/* webpackChunkName: "game-records" */ '../views/GameRecords.vue'), meta: { title: '游戏记录' } }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.afterEach(to => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
